function LightenDarkenColor(col, amt) {
	let usePound = false;
	if (col[0] === '#') {
		//eslint-disable-next-line
		col = col.slice(1);
		usePound = true;
	}

	const num = parseInt(col, 16);

	let r = (num >> 16) + amt;

	if (r > 255) r = 255;
	else if (r < 0) r = 0;

	let b = ((num >> 8) & 0x00ff) + amt;

	if (b > 255) b = 255;
	else if (b < 0) b = 0;

	let g = (num & 0x0000ff) + amt;

	if (g > 255) g = 255;
	else if (g < 0) g = 0;

	return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
}

export const THEMES = {
	default: {
		id: 'T_001',
		name: 'Light',
		account: '#416ba9',
		support: '#8060a9',
		storage: '#008388',
		billing: '#a8ad00',
		colocation: '#00AD5C',
		componentBackground: 'rgba(212, 215, 216, 0.4)',
		boxShadow: LightenDarkenColor('#5b595b', 90),
		neomhorphicShadowLight: LightenDarkenColor('#ffffff', 90),
		neomhorphicActiveShadowLight: 'rgba(255, 255, 255, 0.5)',
		neomhorphicActiveShadowDark: 'rgba(50, 62, 72, 0.75)',
		neomhorphicShadowDark: LightenDarkenColor('#5b595b', 90),
		modalBackground: '#edefef',
		DCBLOX_Gray: '#5b595b',
		Cool_Gray_Light_1: '#d4d7d8',
		Cool_Gray_Light_2: '#dfe1e1',
		Cool_Gray_Light_3: '#edefef',
		Cool_Gray_Med_1: '#a2a9ad',
		Cool_Gray_Med_2: '#c1c5c8',
		Cool_Gray_Med_3: '#cfd2d3',
		Cool_Gray_Dark_2: '#5b6670',
		Cool_Gray_Dark_3: '#7b868c',
		Bright_Blue: '#3192f4',
		defaultFontColor: '#5b6670',
		Med_Rust: '#df6a2e',
		Purple: '#9164cc',
		white: '#ffffff',
		colors: {
			body: '#FFFFFF',
			text: '#000000',
			button: {
				text: '#FFFFFF',
				background: '#000000',
			},
			link: {
				text: 'teal',
				opacity: 1,
			},
		},
		font: 'Tinos',

		res: {
			low: '929px',
			medium: '1345px',
			high: '2241px',
		},
	},
	seaWave: {
		id: 'T_007',
		name: 'Sea Wave',
		account: 'red',
		support: 'blue',
		storage: 'green',
		billing: 'orange',
		colors: {
			body: '#9be7ff',
			text: '#0d47a1',
			button: {
				text: '#ffffff',
				background: '#0d47a1',
			},
			link: {
				text: '#0d47a1',
				opacity: 0.8,
			},
		},
		font: 'Ubuntu',
	},
};
